// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroller[data-v-610512f9]{height:calc(100vh - 300px)}.loading[data-v-610512f9]{opacity:.15}", ""]);
// Exports
module.exports = exports;
